import { useState, useEffect } from 'react';

/** Matches Tailwind md (min 1025px): viewport is "mobile" when width ≤ 1024px. */
const MOBILE_MEDIA = '(max-width: 1024px)';

export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_MEDIA).matches : false,
  );

  useEffect(() => {
    const m = window.matchMedia(MOBILE_MEDIA);
    const listener = () => setIsMobile(m.matches);
    m.addEventListener('change', listener);
    return () => m.removeEventListener('change', listener);
  }, []);

  return isMobile;
}
